import { type CookieOptions } from 'express'
import type Cookies from 'js-cookie'

const isLocalOrE2E =
  process.env.NEXT_PUBLIC_ENV === 'e2e' || process.env.NEXT_PUBLIC_ENV === 'local'

export const baseOptions: Omit<CookieOptions, 'maxAge'> = {
  httpOnly: true,
  secure: !isLocalOrE2E,
  domain: isLocalOrE2E ? undefined : process.env.NEXT_PUBLIC_WHITE_LABEL_ROOT_DOMAIN,
  sameSite: 'lax',
  path: '/',
}

// express/cookies packages, and Nextjs API routes use milliseconds for maxAge
const maxAgeMs = 365 * 24 * 60 * 60 * 1000 // 1 year, in milliseconds

export const cookieOptions: CookieOptions = {
  ...baseOptions,
  maxAge: maxAgeMs,
}

export const secureClientOptions: CookieOptions = {
  ...cookieOptions,
  httpOnly: false,
}

export const secureClientOptionsNoDomain: CookieOptions = {
  ...secureClientOptions,
  domain: undefined,
}

export const guestSecureClientOptionsNoDomain: CookieOptions = {
  ...secureClientOptionsNoDomain,
  maxAge: 7 * 24 * 60 * 60 * 1000, // 7 days, in milliseconds
}

// httpOnly options for the guest ADDRESS cookie (written by the /api/guest route).
export const guestAddressServerCookieOptions: CookieOptions = {
  ...guestSecureClientOptionsNoDomain,
  httpOnly: true,
}

// js-cookie equivalent of guestSecureClientOptionsNoDomain, for writing the
// same guest cookies from the browser. js-cookie takes expires in days rather
// than maxAge, and omits httpOnly because a browser cannot set it which is
// fine, these guest cookies are httpOnly: false by design so the client owns them.
export const guestClientCookieAttributes: Cookies.CookieAttributes = {
  expires: 7,
  path: '/',
  sameSite: 'lax',
  secure: !isLocalOrE2E,
}
